document.addEventListener("DOMContentLoaded", function () {

  if (window.innerWidth > 768) {
    sticykyCheckoutDetails();
  }
  
  reduceInsuranceToSingle();
  removeItemCart();
  updateItemEventListener();

  // remove event
  function removeItemCart() {
    let cartItems = document.querySelectorAll(".custom-cart-item");
    if(cartItems) {
      cartItems.forEach(item => {
        let removeBtn = item.querySelector(".cart-item-remove-btn");
        if(removeBtn) {
          removeBtn.addEventListener("click", e => {
            let variantID = removeBtn.dataset.variantid;
            let itemIndex = removeBtn.dataset.index;
            
            e.target.style.pointerEvents = "none";
            item.querySelector(".price-remove-loader").innerHTML = `<span style="width: 14px; height: 14px;" class="minus-plus-loader"></span>`;
            
            fetch("/cart/change.js", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                line: itemIndex, // can be id: itemID
                quantity: 0
              }),
            })
              .then((response) => response.json())
              .then((data) => {
                if (data) {
                  updateCart();
                }
              })
              .catch((error) => {
                console.error("Error:", error);
              });
            
          })
        }
      })
    }
    
  }

  // update event
  function updateItemEventListener() {
    let allCustomItemCards = document.querySelectorAll(".custom-cart-item");
    if (allCustomItemCards) {
      // console.log("updateItemEventListener allCustomItemCards ->", allCustomItemCards);
      allCustomItemCards.forEach((item) => {
        if (item.querySelector(".minus-plus-btns")) {
          // minus
          item.querySelector(".minus").addEventListener("click", (e) => {
            e.preventDefault();

            let itemKey = e.target.closest(".custom-cart-item").dataset.itemkey;
            let currentQTY = Number(e.target.closest(".minus").dataset.itemqty);
            let newQTY = currentQTY - 1;
            updateCustomCartItem(itemKey, newQTY, item, e.target);
          });

          // plus
          item.querySelector(".plus").addEventListener("click", (e) => {
            e.preventDefault();

            let itemKey = e.target.closest(".custom-cart-item").dataset.itemkey;
            let currentQTY = Number(e.target.closest(".plus").dataset.itemqty);
            let newQTY = currentQTY + 1;
            updateCustomCartItem(itemKey, newQTY, item, e.target);
          });
        }
      });
    }
  }

  // update
  function updateCustomCartItem(itemKey, newQTY, item, eTarget) {
    eTarget.closest(".minus-plus-btn").innerHTML = `<span class="minus-plus-loader"></span>`;
    item.style.pointerEvents = "none";

    fetch("/cart/update.js", {
      method: "post",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ updates: { [itemKey]: newQTY } }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data) {
          updateCart()
          setTimeout(() => {
            item.style.pointerEvents = "auto";
          }, 200);
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }

  // checkInsurance
  function reduceInsuranceToSingle() {
    fetch(window.Shopify.routes.root + "cart.js")
    .then((response) => {
        if (!response.ok) throw new Error("Network response was not ok");
        return response.json();
    })
    .then((data) => {
        const foundInsurance = data.items.some(
            (item) => item.product_id == 7816069972154
        );

        if (foundInsurance) {
            updateInsuranceQty();
        }
      
    })
    .catch((error) => console.error("Error:", error));
  }

  // update insurance qty
  function updateInsuranceQty() {
    let updates = {
      43730484658362: 1,
    };
    fetch(window.Shopify.routes.root + "cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ updates }),
    })
      .then((response) => {
        return response.json();
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }

  // update custom cart
  async function updateCart() {
    const res = await fetch(`${window.Shopify.routes.root}?section_id=custom-cart`);
    const text = await res.text();

    const html = document.createElement("div");
    html.innerHTML = text;

    
    if (html.querySelector(".custom-cart-empty")) {
      const customDrawerCartInnerHTMLNEWCONTENT = html.querySelector(".custom-cart-inner").innerHTML;
      const customDrawerCartInnerHTMLOLDCONTENT = document.querySelector(".custom-cart-inner").innerHTML = customDrawerCartInnerHTMLNEWCONTENT;

      const customCartQTYNEWCONTENT = html.querySelector(".custom-cart-qty").innerHTML;
      const customCartQTYOLDCONTENT = document.querySelector(".custom-cart-qty").innerHTML = customCartQTYNEWCONTENT;
      
    } else {
      const customDrawerCartItemsHTMLNEWCONTENT = html.querySelector(".custom-cart-product-items").innerHTML;
      const customDrawerCartItemsHTMLOLDCONTENT = document.querySelector(".custom-cart-product-items");

      if (customDrawerCartItemsHTMLOLDCONTENT) {
        customDrawerCartItemsHTMLOLDCONTENT.innerHTML = customDrawerCartItemsHTMLNEWCONTENT;
        const customDrawerCheckoutBtnHTMLNEWCONTENT = html.querySelector(".custom-drawer-checkout-btn").innerHTML;
        const customDrawerCheckoutBtnHTMLOLDCONTENT = document.querySelector(".custom-drawer-checkout-btn").innerHTML = customDrawerCheckoutBtnHTMLNEWCONTENT;

        const customCartQTYNEWCONTENT = html.querySelector(".custom-cart-qty").innerHTML;
        const customCartQTYOLDCONTENT = document.querySelector(".custom-cart-qty").innerHTML = customCartQTYNEWCONTENT;
        
      } else {
        const customDrawerCartInnerHTMLNEWCONTENT = html.querySelector(".custom-cart-inner").innerHTML;
        const customDrawerCartInnerHTMLOLDCONTENT = document.querySelector(".custom-cart-inner").innerHTML = customDrawerCartInnerHTMLNEWCONTENT;
 
      }
    }

    removeItemCart();
    updateItemEventListener();
  
  }

  // sticky Checkout
  function sticykyCheckoutDetails() {
    const targetElement = document.querySelector('sticky-header');
    const checkoutDetails = document.querySelector(".custom-drawer-footer");
    if(checkoutDetails) {
      checkoutDetails.style.position = "sticky";
    
      const callback = (entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            checkoutDetails.style.top = "150px";
          } else {
            checkoutDetails.style.top = "20px";
          }
        });
      };
      
      const options = {
        root: null,
        rootMargin: '0px',
        threshold: 0.1
      };
  
      const observer = new IntersectionObserver(callback, options);
      observer.observe(targetElement); 
    }

  }

});
